import enAPI from "./en/api";
import enAuth from "./en/auth";
import enCommitmentsStore from "./en/commitmentsStore.js";
import enCommon from "./en/common";
import enGokr from "./en/gokr";
import enLoadingMessages from "./en/loadingMessages";
import enMeeting from "./en/meeting";
import enMeetingAgendaStore from "./en/meetingAgendaStore";
import enMeetingStore from "./en/meetingStore";
import enMeetingTopics from "./en/meetingTopics";
import enMessages from "./en/index";
import enMyCommitments from "./en/myCommitments.js";
import enProfile from "./en/profile";
import enSchedule from "./en/schedule.js";
import enScheduleStore from "./en/scheduleStore.js";
import enSession from "./en/session";
import enSidebar from "./en/sidebar";
import enStore from "./en/store";
import enTeamHealth from "./en/teamHealth";
import enTeamManagement from "./en/teamManagement";
import enTeamOverviewStore from "./en/teamOverviewStore";

const en = {
	api: enAPI,
	auth: enAuth,
	commitmentsStore: enCommitmentsStore,
	common: enCommon,
	gokr: enGokr,
	loadingMessages: enLoadingMessages,
	meeting: enMeeting,
	meetingAgendaStore: enMeetingAgendaStore,
	meetingStore: enMeetingStore,
	meetingTopics: enMeetingTopics,
	message: enMessages,
	myCommitments: enMyCommitments,
	profile: enProfile,
	schedule: enSchedule,
	scheduleStore: enScheduleStore,
	session: enSession,
	sidebar: enSidebar,
	store: enStore,
	teamHealth: enTeamHealth,
	teamManagement: enTeamManagement,
	teamOverviewStore: enTeamOverviewStore,
};

export default {
	en,
	"en-US": en,
};



// WEBPACK FOOTER //
// ./src/lang/index.js